<div class="spinner-overlay" *ngIf="isLoading">
  <mat-spinner></mat-spinner>
</div>